import type moment from 'moment-timezone'
import type { Validator } from '../Validator'
import { validateCompleteError, validateCompleteSuccess } from '../Validator'

const getDefaultInvalidMessage = (data: moment.Moment) => {
    switch (data.invalidAt()) {
        case -1:
            return "Formato non valido, l'anno deve essere a 4 cifre"
        case 0:
            return "L'anno inserito non è valido"
        case 1:
            return 'Il mese inserito non è valido'
        case 2:
            return 'Il giorno inserito non è valido'
        case 3:
            return 'Le ore inserite non sono valide'
        case 4:
            return 'I minuti inseriti non sono validi'
        case 5:
            return 'I secondi inseriti non sono validi'
        case 6:
            return 'I millisecondi inseriti non sono validi'
        default:
            return 'Formato non valido'
    }
}

export const momentValidator = (
    options: Validator.options
): Validator.validatorSingle<unknown, moment.Moment | undefined> => ({
    isAsync: false,
    validate: (value, data) => {
        if (typeof data === 'undefined') {
            return validateCompleteSuccess()
        }

        return data.isValid()
            ? validateCompleteSuccess()
            : validateCompleteError(options, getDefaultInvalidMessage(data))
    },
})
